<template>
  <div>
    <div
      class="spinner-border spinner-border-sm text-secondary"
      role="status"
      v-if="status === 'loading'"
    ></div>
    <div class="text-danger" v-if="status === 'failed'">
      <fa-icon icon="times" class="mr-1"></fa-icon>
      <span
        >There was an error when connecting to our servers. Try again
        later.</span
      >
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

import store from "@/store/root";

export default defineComponent({
  name: "StatusIndicator",
  setup() {
    const status = computed(() => store.state.status);

    return { status };
  }
});
</script>
